import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import _ from 'lodash'
import axios from 'axios'

let sendApprove = function ({ params, sendApprove, dispatch, dispatchType }) {
  let filterIndexRowsApprove = []
  let filterIndexRowsSave = []
  let approveRow = 0
  let rejectRow = 0
  let dataRows = params.dataRows
  let codappr = params.codappr

  let dataRowsApprove = dataRows.filter(dataRow => {
    if (typeof dataRow.flgStaappr !== 'undefined') {
      return dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== ''
    } else {
      return false
    }
  })
  for (let dataRowApprove of dataRowsApprove) {
    if (dataRowApprove.flgStaappr === 'A') {
      approveRow++
    } else if (dataRowApprove.flgStaappr === 'N') {
      rejectRow++
    }
    filterIndexRowsApprove.push({
      p_staappr: (typeof dataRowApprove.flgStaappr !== 'undefined') ? dataRowApprove.flgStaappr : '',
      p_codempid_query: (typeof dataRowApprove.codempid !== 'undefined') ? dataRowApprove.codempid : '',
      p_codcomp: (typeof dataRowApprove.codcomp !== 'undefined') ? dataRowApprove.codcomp : '',
      p_codpos: (typeof dataRowApprove.codpos !== 'undefined') ? dataRowApprove.codpos : '',
      p_numlvl: (typeof dataRowApprove.numlvl !== 'undefined') ? dataRowApprove.numlvl : '',
      p_dtemonth: (typeof dataRowApprove.dtemonth !== 'undefined') ? dataRowApprove.dtemonth : '',
      p_codplan: (typeof dataRowApprove.codplan !== 'undefined') ? dataRowApprove.codplan : '',
      p_codtparg: (typeof dataRowApprove.codtparg !== 'undefined') ? dataRowApprove.codtparg : '',
      p_dtetrst: (typeof dataRowApprove.dtetrst !== 'undefined') ? dataRowApprove.dtetrst : '',
      p_dtetren: (typeof dataRowApprove.dtetren !== 'undefined') ? dataRowApprove.dtetren : '',
      p_flgqlify: (typeof dataRowApprove.flgqlify !== 'undefined') ? dataRowApprove.flgqlify : '',
      p_codappr: (typeof codappr !== 'undefined') ? codappr : '',
      p_nummemo: (typeof dataRowApprove.nummemo !== 'undefined') ? dataRowApprove.nummemo : '',
      p_codcours: (typeof dataRowApprove.codcours !== 'undefined') ? dataRowApprove.codcours : '',
      p_dteyear: (typeof dataRowApprove.dteyear !== 'undefined') ? dataRowApprove.dteyear : '',
      p_numclseq: (typeof dataRowApprove.numclseq !== 'undefined') ? dataRowApprove.numclseq : '',
      p_flg: (typeof dataRowApprove.flg !== 'undefined') ? dataRowApprove.flg : ''
    })
  }
  let dataRowsSave = dataRows.filter(dataRow => {
    if (typeof dataRow.flgStaappr !== 'undefined') {
      return (dataRow.flgStaappr === 'P' || dataRow.flgStaappr.trim() === '') && (dataRow.flg === 'delete' || dataRow.flg === 'add')
    } else {
      return dataRow.flg === 'delete' || dataRow.flg === 'add'
    }
  })
  for (let dataRowSave of dataRowsSave) {
    filterIndexRowsSave.push({
      p_staappr: (typeof dataRowSave.flgStaappr !== 'undefined') ? dataRowSave.flgStaappr : '',
      p_dteyear: (typeof dataRowSave.dteyear !== 'undefined') ? dataRowSave.dteyear : '',
      p_codcours: (typeof dataRowSave.codcours !== 'undefined') ? dataRowSave.codcours : '',
      p_codempid_query: (typeof dataRowSave.codempid !== 'undefined') ? dataRowSave.codempid : '',
      p_codcomp: (typeof dataRowSave.codcomp !== 'undefined') ? dataRowSave.codcomp : '',
      p_codpos: (typeof dataRowSave.codpos !== 'undefined') ? dataRowSave.codpos : '',
      p_codplan: (typeof dataRowSave.codplan !== 'undefined') ? dataRowSave.codplan : '',
      p_numlvl: (typeof dataRowSave.numlvl !== 'undefined') ? dataRowSave.numlvl : '',
      p_nummemo: (typeof dataRowSave.nummemo !== 'undefined') ? dataRowSave.nummemo : '',
      p_flgtrn: (typeof dataRowSave.v_flgtrn !== 'undefined') ? dataRowSave.v_flgtrn : '',
      p_flg: (typeof dataRowSave.flg !== 'undefined') ? dataRowSave.flg : ''
    })
  }

  if (dataRowsApprove.length + dataRowsSave.length > 0) {
    let domRemark = constLabels('msgConfirmSave')
    if (approveRow > 0 || rejectRow > 0) {
      let domRemarkApprove = '<textarea id="remark-approve" class="form-control" maxlength="500"></textarea>'
      let domRemarkReject = '<textarea id="remark-reject" class="form-control" maxlength="500"></textarea>'
      domRemark += '<div class="swal-approve-remark">'
      domRemark += '  <div class="content-header">'
      domRemark += (approveRow > 0) ? '<div class="item-header">' + 'Remark for Approve' + '</div>' + domRemarkApprove : ''
      domRemark += (rejectRow > 0) ? '<div class="item-header">' + 'Remark for Reject' + '</div>' + domRemarkReject : ''
      domRemark += '  </div>'
      domRemark += '  <div class="content-summary text-skin">'
      domRemark += (approveRow > 0) ? '<div class="item-summary">' + 'No. of Approved' + ' ' + approveRow + ' ' + 'records' + '</div>' : ''
      domRemark += (rejectRow > 0) ? '<div class="item-summary">' + 'No. of Rejected' + ' ' + rejectRow + ' ' + 'records' + '</div>' : ''
      domRemark += '  </div>'
      domRemark += '</div>'
    }
    swal({
      title: constLabels('confirmTitle'),
      text: domRemark,
      showCancelButton: true,
      closeOnConfirm: true,
      closeOnCancel: true,
      html: true
    },
    function (isConfirm) {
      if (isConfirm) {
        let sendParamsApprove = {}
        if (dataRowsApprove.length > 0) {
          sendParamsApprove = {
            p_qtyemp: approveRow,
            eventBtn: 'approve',
            param_json: JSON.stringify(filterIndexRowsApprove),
            remarkApprove: (approveRow > 0) ? document.getElementById('remark-approve').value : '',
            remarkReject: (rejectRow > 0) ? document.getElementById('remark-reject').value : ''
          }
        }
        let sendParamsSave = {}
        if (dataRowsSave.length > 0) {
          sendParamsSave = {
            p_qtyemp: approveRow,
            eventBtn: 'save',
            param_json: JSON.stringify(filterIndexRowsSave),
            remarkApprove: (approveRow > 0) ? document.getElementById('remark-approve').value : '',
            remarkReject: (rejectRow > 0) ? document.getElementById('remark-reject').value : ''
          }
        }
        swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
        if (!_.isEmpty(sendParamsApprove) && !_.isEmpty(sendParamsSave)) {
          axios.all([
            sendApprove(sendParamsApprove),
            sendApprove(sendParamsSave)
          ])
          .then(axios.spread((responseApprove, responseSave) => {
            const data = JSON.parse(responseApprove.request.response)
            swal({
              title: '', text: data.response, html: true, type: 'success'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
            dispatch(dispatchType, params.searchIndex)
          }))
          .catch((error) => {
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          })
        } else if (!_.isEmpty(sendParamsApprove)) {
          sendApprove(sendParamsApprove)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
              dispatch(dispatchType, params.searchIndex)
            })

            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        } else if (!_.isEmpty(sendParamsSave)) {
          sendApprove(sendParamsSave)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
              dispatch(dispatchType, params.searchIndex)
            })

            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      }
    })
  } else {
    swal({
      title: 'Confirmation',
      text: 'Please select at least 1 record.'
    })
  }
}

export { sendApprove }



// WEBPACK FOOTER //
// ./src/components/hrms74e/sendApproveHrms74e.js